import { WaypointDTO } from './dto/WaypointDTO';
import { LocationDTO } from './dto/LocationDTO';

export class TableLocationWaypoint{
    constructor(
        public location: LocationDTO,
        public waypoint: WaypointDTO
    ){}
}